import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin, InputNumber, Button } from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
// import { apiConfig, labelConfig, staticConfig } from "../../../../customer/customer.config";
import { apiConfig, labelConfig, staticConfig } from "../../../contractbooking.config";
import SuccessModal from "../../../component/SuccessModal";
import dayjs from "dayjs";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";

const { TextArea } = Input;
const DisburseTreasuryBillContract = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  function onCancel() {
    navigate("/view-contract-booking-treasury-bill", { state: state });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.GetTreasuryBillContract}/${state.key}/disburse`;
    // const params = {
    //   command: "disburse",
    // };
    formValues.disbursementDate = BOM.DateTime(formValues.disbursementDate, "only-date");

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      // params,
    };
    // console.log(body);
    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsModalVisible(true);

        // BOM.AlertMsg(cnt.SUCCESS, "Contract was Disbursed successfully");
        // navigate("/view-contract-booking-treasury-bill", {
        //   state: { ...state, statusValue: "approved" },
        // });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  React.useEffect(() => {
    form.setFieldsValue({ disbursementDate: dayjs() });
  }, []);

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={"Disburse Deal"} pageItems={[]} />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Contract Ref ID: ${state.contractRefId}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Disbursed on"}
                  name={"disbursementDate"}
                  style={{ flex: 1, marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker suffixIcon={<CalendarIcon color="#667085" width={20} />} disabledDate={BOM.DisabledAfterCurrentDate} style={{ width: "100%", height: "44px", marginBottom: 0 }} className="bond-date-picker" />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Note is required",
                  //   },
                  // ]}
                  label={"Note"}
                  name={"note"}
                >
                  <TextArea rows={3} />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "15%",
                  padding: "8px",

                  width: "100%",
                }}
              >
                <Button
                  style={{
                    margin: "0 8px",
                    height: 44,
                    fontSize: 16,
                    background: "#FFFFFF",
                    borderColor: "#D0D5DD",
                  }}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  style={{
                    background: "#BA24D5",
                    borderColor: "#BA24D5",
                    height: 44,
                    fontSize: 16,
                    color: "white",
                  }}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </div>
              {/* <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              /> */}
            </Row>
          </Form>
        </Card>
        <SuccessModal visible={isModalVisible} onClose={onCancel} successMessage={"Contract Disbursed successfully"} />
      </Spin>
    </MainLayout>
  );
};
export default DisburseTreasuryBillContract;
